export default __webpack_public_path__ + "static/media/pvn-arte-2.4a24f04a.webp";